<template>
  <RangePicker
    :title="$t('calculators_common.number_of_games')"
    :description="$t('calculators_common.select_number_of_games')"
    type="games"
    :max="10"
  />
  <option-picker />
  <ChampionsPicker />
</template>

<script setup>
import OptionPicker from "./pickers/OptionPicker.vue";
import RangePicker from "../commonpickers/RangePicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import { onMounted, watch } from "vue";

const {
  getDetails,
  setDetails,
  setPackExtraOptions,
  setServer,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack } = useGameStore();

const handleDetails = () => {
  clearCheckout();

  setDetails({
    numberOfGames: 1,
  });

  setPlatform({
    platform: 1,
  });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});
</script>
